export default __webpack_public_path__ + "47b0626ac518018fbcea29e9ce1c8cc2.png";